'use client';

import { usePageLoader } from '@/hooks/usePageLoader';
import { useSnackbar } from '@/hooks/useSnackbar';
import { ibowClient } from '@/init/ibowClient';
import {
  Field,
  RequestPasswordResetResolver,
  RequestPasswordResetType,
} from '@/schemas/RequestPasswordResetSchema';
import { Route } from 'next';
import { usePathname, useRouter } from 'next/navigation';
import { useForm, useWatch } from 'react-hook-form';

export const useLogic = () => {
  const router = useRouter();
  const pathname = usePathname();
  const { openSnackbar } = useSnackbar();
  const { setLoading } = usePageLoader();
  const { control, clearErrors, handleSubmit } =
    useForm<RequestPasswordResetType>({
      resolver: RequestPasswordResetResolver,
      defaultValues: {
        field: Field.ibowid,
        mail: '',
        phone: '',
        ibowid: '',
      },
    });

  control.register('field', {
    onChange: () => {
      clearErrors();
    },
  });

  const selectedField = useWatch({ control, name: 'field' });
  const fieldName = control.register(selectedField).name;
  const label =
    selectedField === 'mail'
      ? 'メールアドレス'
      : selectedField === 'phone'
        ? '電話番号'
        : 'iBowID';

  const onClickCancel = () => {
    window.location.href = '/signin';
  };

  const onClickSubmit = handleSubmit((data) => {
    setLoading(true);
    ibowClient.authentication
      .postRequestPasswordReset({
        body: {
          mail: data.mail || '',
          phone: data.phone || '',
          ibowid: data.ibowid || '',
        },
      })
      .then((res) => {
        router.push(`${pathname}?check_token=${res.token}` as Route);
        setLoading(false);
      })
      .catch((err) => {
        openSnackbar(err.body.message, 'error');
        setLoading(false);
      });
  });

  return {
    control,
    fieldName,
    label,
    onClickCancel,
    onClickSubmit,
  };
};
